import request from '@/config/axios'

export interface ActivityWriteoffVO {
  id?: number
  activityId?: number
  awardCodeId?: number
  code?: string
  memberId?: number
  writeoffUser?: number
  writeoffTime?: string
  remark?: string
  createTime?: string
}

export interface ActivityWriteoffPageReqVO extends PageParam {
  activityId?: number
  code?: string
  writeoffTime?: string[]
}

export const submitActivityWriteoff = (data: { code: string }) => {
  return request.post({ url: '/promotion/activity-writeoff/submit', data })
}

export const getActivityWriteoffPage = (params: ActivityWriteoffPageReqVO) => {
  return request.get({ url: '/promotion/activity-writeoff/page', params })
}

export const exportActivityWriteoff = (params: ActivityWriteoffPageReqVO) => {
  return request.get({ url: '/promotion/activity-writeoff/export', params })
}
